// src/data/claimVersion.js - RULING 305.11 (by delegation, Record 651): the numbered versions of 305.2 and the "FV" of
// 305.5. Bob, 305.2: the claimant's draft is v1; while the Local Chairperson holds it, it is his draft; "when he submits it
// to either of the claimant or the gc for further review and handling, his becomes copy v2 and it works like that
// internally between the 3 union people until the claim is finally sent to ... the carrier, and the file name includes FV
// at the end before the dot(.) file extension". 305.5: the tag is PART of the file name and always its LAST part.
//
// COUNTED, NOT STORED TWICE. Every hand-off among the three is already a recorded act on the claim:
//   back to the claimant  ruling 72's return            claim.returnCount (claimReturn.js)
//   claimant re-submits   the returned draft filed again  one per return, except a return not yet re-submitted
//   up to the GC          the Local Chairperson's forward  claim.gcForwardCount (written with status gc_review)
// So the version is 1 + those hand-offs; the carrier's copy - once service on the carrier is recorded (presentedOn) - is FV.
// PURE.
const n = (v) => { const x = Number(v); return isFinite(x) && x > 0 ? Math.floor(x) : 0; };

export function handoffCount(claim) {
  const c = claim || {};
  const returns = n(c.returnCount);
  const awaitingResubmission = returns > 0 && String(c.status || '') === 'draft' ? 1 : 0;
  return returns + (returns - awaitingResubmission) + n(c.gcForwardCount);
}
export function versionNumber(claim) { return 1 + handoffCount(claim); }
export function isFinalVersion(claim) { return !!(claim && String(claim.presentedOn || '').trim()); }
// 'FV' for the carrier's copy, else 'v' + the number.
export function versionTag(claim) { return isFinalVersion(claim) ? 'FV' : 'v' + versionNumber(claim); }
// The tag as the LAST part of a file name, immediately before its extension (305.5).
export function withVersionTag(fileName, claim) {
  const f = String(fileName || '');
  const dot = f.lastIndexOf('.');
  return dot > 0 ? f.slice(0, dot) + '_' + versionTag(claim) + f.slice(dot) : f + '_' + versionTag(claim);
}
